import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { AppError } from '../common/errors/app-error';
import { NotFoundError } from '../common/errors/not-found-error';
import { Connector } from '../utils/connector.model';
import { of } from 'rxjs';

@Injectable()
export class KrameriusService {

  private static STREAM_DC = 'DC';
  private static STREAM_MODS = 'BIBLIO_MODS';

  private BASE_URL = Connector.KRAMERIUS_URL;

  constructor(private http: Http) { }

  getDc(uuid: string) {
    const url = this.getItemStreamUrl(uuid, KrameriusService.STREAM_DC);
    return this.http.get(url)
      .map(response => response['_body'])
      .catch(this.handleError);
  }

  getMods(uuid: string) {
    const url = this.getItemStreamUrl(uuid, KrameriusService.STREAM_MODS);
    return this.http.get(url)
      .map(response => response['_body'])
      .catch(this.handleError);
  }

  /** @deprecated */
  getItem(uuid: string) {
    const url = this.getItemUrl(uuid);
    return this.http.get(url)
      .map(response => response.json())
      .catch(this.handleError);
  }

  getItemFromSolr(uuid: string) {
    const baseUrl = 'https://kramerius.difmoe.eu/search/api/client/v7.0';

    const url = baseUrl + '/search?fl=*&q=pid:"' + uuid + '"';
    return this.http.get(url)
      .map(response => response.json())
      .catch(this.handleError);
  }

  getChildren(uuid: string) {
    //const url = this.getItemUrl(uuid) + '/children';
    //console.log("getChildren() uuid: ", uuid);
    const baseUrl = 'https://kramerius.difmoe.eu/search/api/client/v7.0';

    //model,pid,accessibility,title.search,page.type
    //date_range_end.year nebo date_range_start.year as year for periodicalvolume
    //part.number.sort as number for periodicalvolume
    //date.str as date for periodicalitem
    //part.number.sort as number for periodicalitem
    const url = baseUrl + '/search?fl=model,pid,accessibility,title.search,page.type,page.number,date_range_end.year,part.number.str,date.str&q=own_parent.pid:"' + uuid + '"&rows=1000';
    return this.http.get(url)
      .map(response => response.json())
      .map(res => res['response']['docs'])
      .catch(this.handleError);
  }

  /**
   * @deprecated
   */
  getCollections() {
    // const url = this.getApiUrl() + '/vc';
    // return this.http.get(url)
    //   .map(response => response.json())
    //   .catch(this.handleError);

    console.warn('getCollections is deprecated. Returning empty array.');
    return of([]);
  }

  getThumbUrl(uuid: string) {
    //return this.getItemUrl(uuid) + '/thumb';
    //https://kramerius.difmoe.trinera.cloud/search/api/client/v7.0/items/uuid:9129c1da-2bda-4314-b3b2-8ac97a0c34be/image/thumb
    return `${this.BASE_URL}/search/api/client/v7.0/items/${uuid}/image/thumb`;
  }

  getFullImageUrl(uuid: string) {
    return `${this.BASE_URL}/search/img?pid=${uuid}&stream=IMG_FULL&action=GETRAW`;
  }

  getSolrResult(query: string) {
    console.log("getSolrResult() query: ", query);
    //const baseUrl = this.getApiUrl();
    const baseUrl = "https://kramerius.difmoe.eu/search/api/client/v7.0/";
    const url = baseUrl + '/search?' + query;
    return this.http.get(url)
      .map(response => response.json())
      .catch(this.handleError);
  }

  private getItemStreamUrl(uuid: string, stream: string) {
    const baseUrl = "https://kramerius.difmoe.eu/search/api/client/v7.0/";
    let url: string = '';
    switch (stream) {
      case 'DC':
        return baseUrl + '/items/' + uuid + '/metadata/dc';
      case 'BIBLIO_MODS':
        return baseUrl + '/items/' + uuid + '/metadata/mods';
      default:
        return 'STREAM_NOT_SUPPORTED:' + stream;
    }
  }

  private getItemUrl(uuid: string): string {
    return this.getApiUrl() + '/item/' + uuid;
  }

  private getApiUrl(): string {
    return this.BASE_URL + '/search/api/v5.0';
  }

  private handleError(error: Response) {
    if (error.status === 404) {
      return Observable.throw(new NotFoundError());
    }
    return Observable.throw(new AppError(error));
  }




}
